import { GraphBuilder } from '../graph/builder';
import { ComponentDef } from './types';

export const tpOverlapComponent: ComponentDef = {
  id: 'tp-overlap',
  name: 'TP Overlap',
  description: 'Overlap tensor-parallel AllReduce communication with compute to hide latency.',
  category: 'parallelism',
  params: [
    { name: 'd_model', label: 'Model dimension', type: 'number', default: 512, min: 64, max: 4096, step: 64 },
    { name: 'tp_size', label: 'TP size', type: 'number', default: 4, min: 2, max: 16, step: 1 }
  ],
  buildGraph: (params) => {
    const d_model = Number(params.d_model);
    const tp_size = Number(params.tp_size);

    const g = new GraphBuilder();
    g.input('x', [d_model]);

    g.split('shard', 'x', [d_model / tp_size], 'col');
    g.linear('compute_a', 'shard', [d_model / tp_size, d_model / tp_size]);
    g.allreduce('comm', 'compute_a', [d_model / tp_size]);
    g.linear('compute_b', 'comm', [d_model / tp_size, d_model / tp_size]);
    g.allgather('gather', 'compute_b', [d_model]);
    g.output('out', 'gather');
    return g.build();
  }
};
